var Marionette = require('marionette'),
    _ = require('underscore');

require('chosenBundle');


module.exports = Marionette.ItemView.extend({

    initialize: function(options) {

        this.onChange = options.onChange;
        this.selectedCodes = options.selectedCodes;
        this.availableCodes = options.availableCodes;
        this.renderDisabled = options.renderDisabled;

    },

    template: require('./template.hbs'),

    onRender: function() {

        this.unwrap(); // required for plugin markup -- see note in consultGroupSelector

        if ( this.selectedCodes && this.selectedCodes.length > 0 ) {

            this.setUiValueFromSelectedCodes();
        }
    },

    /* Note: order of the provided codes will not be kept in tact -- would like to fork or use plugin if problematic */
    setUiValueFromSelectedCodes: function() {

        this.$el.val( this.selectedCodes.map( function( reasonCode ) {
            return reasonCode.get('code');
        }));

        this.$el.trigger('chosen:updated'); // For when called externally

    },

    serializeData: function() {

        return {
            renderDisabled: this.renderDisabled || this.availableCodes.length < 1,
            reasonCodes: this.availableCodes.toJSON()
        };

    },

    // ( Chosen must be in DOM )
    onShow: function() {

        this.$el.chosen({
            width: '100%',
            placeholder_text_multiple: 'Select Reason Codes...'
        }).on('change', _.bind( function() {

            this.onChange( this.getSelectedReasonCodes() );

        }, this) );
    },

    getSelectedReasonCodes: function() {

        // Value on multi-selects doesn't return disabled options, so use this:
        var aSelectedCodes = this.$('option:selected').map( function(i, el) {
            return el.value;
        }).get();

        if ( aSelectedCodes.length < 1 )
            return null;

        return _.map( aSelectedCodes, function(code) {
            return this.availableCodes.findWhere({code: code});
        }, this);

    },


    enable: function() {

        this.el.disabled = false;
        this.$el.trigger('chosen:updated');

    },

    disable: function() {

        this.el.disabled = true;
        this.$el.trigger('chosen:updated');

    },

    disableOption: function( code ) {
        this._setOptionDisabled( code, true );
    },

    enableOption: function( code ) {
        this._setOptionDisabled( code, false );
    },

    /**  Fail silently if option doesn't exist **/
    _setOptionDisabled: function( code, disable ) {

        var $option = this._getOptionFromDOM( code );

        if ( $option && $option.length > 0 ) {
            $option[0].disabled = disable;
        }

        this.$el.trigger('chosen:updated');

    },

    _getOptionFromDOM: function( code ) {
        return this.$('option[value=' + code + ']');
    },


    onBeforeDestroy: function() {

        this.$el
            .off()
            .chosen('destroy');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/dialog/reasonCodeSelector/view.js
 ** module id = 241
 ** module chunks = 0
 **/